import React, {
  Component,
  PropTypes
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {fetchCipIdeaAction, fetchCipFilesAction, postCipProgressAction} from '../actions/';
import ProcessCipPage from '../components/ProcessIdeas/ProcessCipPage';

class ProcessCIPContainer extends Component {

  constructor(props) {
    super(props);
    const {ideaId} = this.props.params;
    this.state = {ideaId : ideaId};
  }

  render() {
    const { actions } = this.props;
    const { ideaId } = this.state;
    const { cipIdea } = this.props;
    const { cipFiles } = this.props;
    const { authInfo } = this.props;
    return <ProcessCipPage authInfo={authInfo} actions={actions} ideaId = {ideaId} cipIdea={cipIdea} cipFiles={cipFiles}/>;
  }

  componentDidMount() {
      const {ideaId} = this.props.params;
      const {actions} = this.props;
      actions.fetchCipIdeaAction(ideaId).then(() => {
        actions.fetchCipFilesAction (ideaId)
      }).then(() => { this.setState({ ideaId : ideaId })});
  }

  componentWillReceiveProps(nextProps) { 
   
  }

}

ProcessCIPContainer.propTypes = {
  actions: PropTypes.shape({})
};

function mapStateToProps(state) {
  const props = {
    cipIdea : state.currentCipIdea, 
    cipFiles : state.currentCipFiles, 
    authInfo : state.authInfo
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {fetchCipIdeaAction, fetchCipFilesAction, postCipProgressAction};
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(ProcessCIPContainer);



// WEBPACK FOOTER //
// ./containers/ProcessCIPContainer.js